import { render } from "./OnboardingTradesIcon.vue?vue&type=template&id=03d9a46d"
import script from "./OnboardingTradesIcon.vue?vue&type=script&lang=js"
export * from "./OnboardingTradesIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__